import { IReportData } from "../../models/report-data-interface";
import { Component, Input } from "@angular/core";

@Component({
  selector: "printAndExport",
  template: `
            <!--<div class="paddingTop noPrint">-->
            <div class="noPrint">
                <button class="ui basic button" id="printButton" (click)="print()" >
                    <i class="print icon"></i>
                    Print
                </button>
                <button *ngIf="!hideExport" class="ui basic button" id="exportButton" (click)="export()">
                    <i class="save icon"></i>
                    Export
                </button>
            </div>
    `,
})

export class PrintAndExportComponent {
    @Input() public exportData: IReportData;
    @Input() public exportName: string;
    @Input() public hideExport: boolean;

    public print() {
        window.print();
    }

    public export() {
        let csvData = encodeURI(this.exportData.toCSV());
        let link = document.createElement("a");
        link.setAttribute("href", csvData);
        link.setAttribute("download", `${this.exportName}.csv`);
        document.body.appendChild(link);
        this.exportLinkClick(link);
    }

    public getPrintHTML(): string {
        let data = this.getReportContinerHTML();
        let headArray = this.getHeaderData();
        let head = "";
        headArray.forEach(row => {
          head += row;
        });
        head += "<style>.noPrint {display: none;} " +
            "a { pointer-events: none; cursor:default; display: inline-block; }</style>";

        return `<html><head>${head}</head><body class="maxWrapper" style="background: white;">${data}
                <ng2common-site-footer style="color: #D6001C" [jurisdiction]="'NSW'"></ng2common-site-footer>
                </body></html>`;
    }

    public exportLinkClick(link: HTMLAnchorElement) {
        link.click();
    }

    private getReportContinerHTML(): string {
        return window.document.getElementById("reportContainer").innerHTML;
    }

    private getHeaderData(): Array<string> {
        return window.document.head.innerHTML.split("\n");
    }
}



// WEBPACK FOOTER //
// ./client/app/shared/reportControls/print-and-export-component.ts